module.exports = __webpack_public_path__ + "img/close-doc.f35f0c52.jpg";